import { render, staticRenderFns } from "./AllBeneficiaryComponent.vue?vue&type=template&id=017d8f16&scoped=true"
import script from "./AllBeneficiaryComponent.vue?vue&type=script&lang=js"
export * from "./AllBeneficiaryComponent.vue?vue&type=script&lang=js"
import style0 from "./AllBeneficiaryComponent.vue?vue&type=style&index=0&id=017d8f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017d8f16",
  null
  
)

export default component.exports